
import { getBytesCount } from '@utils/data';

const validateGroupTime = (rule, value, callback, context) => {
    if (!context.formData.startTime || !context.formData.endTime) {
        callback(new Error('请输入团购时间'));
    } else {
        callback();
    }
}


const validateName = (rule, value, callback, context) => {
    if (getBytesCount(value) > 200) {
        callback(new Error('字符数不能超过200'))
    } else {
        callback();
    }
}
const validateGoodsName = (rule, value, callback, context) => {
    if (getBytesCount(value) > 120) {
        callback(new Error('字符数不能超过120'))
    } else {
        callback();
    }
}
const validateGoodsDesc = (rule, value, callback, context) => {
    if (getBytesCount(value) > 2000) {
        callback(new Error('字符数不能超过2000'))
    } else {
        callback();
    }
}
const validateImages = async (rule, value, callback, context) => {
    let errMsg = await context.$refs.picUrlRef.method_validImage()
    if (errMsg) {
        callback(new Error(errMsg));
    } else {
        callback();
    }

}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}
const mainRules = function (context) {
    return {
        groupTitle: [
            { required: true, message: '请输入团购名称' },
            { validator: contextWrap(validateName, context) },
        ],
        groupTime: [
            { required: true, validator: contextWrap(validateGroupTime, context) },
        ],
        groupPublishConfig: [
            { required: true, message: '请选择发布方式' },
        ],
    }
}
const prodRules = function (context) {
    return {
        goodsName: [
            { required: true, message: '请输入名称' },
            { validator: contextWrap(validateGoodsName, context) },
        ],
        categoryName: [
            { required: true, message: '请输入分类名' },
        ],
        goodsDesc: [
            { required: true, message: '请输入商品描述' },
            { validator: contextWrap(validateGoodsDesc, context) },
        ],
        picUrl: [
            // { required: true, message: '至少选择1张图片' },
            { validator: contextWrap(validateImages, context) }
        ],
    };
}
const picUrlLimits = {
    limitSuffix: '.jpg,.png,.jpeg',
    limitSize: 5 * 1024 * 1024,
    limitWidth: [480, 1200],
    limitHeight: [0, 1500],
    limitNums: 20,
    aspectRatio: [1],
    aspectRatioText: '1:1',
    size: 150,
    mainImgNums: 5,
}
const specImgLimits = {
    limitSize: 1 * 1024 * 1024,
    limitHeight: [0, 1200],
    limitWidth: [0, 1200],
    limitSuffix: '.jpg,.png,.jpeg',
}

export {
    prodRules,
    mainRules,
    picUrlLimits,
    specImgLimits
}